import { Extension } from '@tiptap/core'
import { LIST_ITEM_NODE_NAME } from '../../../../../../backend/src/tiptap/editor/extensions/marks/suggestion'
import { liftListItemSingleLevel, mergeListItemBackward, runListCommandWithTracking } from './list-track-changes'
import { TrackChangesPluginOptions, createTrackChangesPlugin } from './track-changes-plugin'

// Higher than the default 100 used by `@tiptap/extension-list`'s ListItem and
// ListKeymap so our Tab / Shift-Tab / Backspace handlers run first. Without this,
// the list extension's default keymap dispatches `sinkListItem`/`liftListItem`
// directly — silently applying the structural change without a suggestion, and
// outdenting a list item on Backspace instead of merging it away.
const TRACK_CHANGES_PRIORITY = 200

export const TrackChangesExtension = Extension.create<TrackChangesPluginOptions>({
  name: 'trackChanges',

  priority: TRACK_CHANGES_PRIORITY,

  addOptions() {
    return {
      getEnabled: () => false,
      getCurrentUser: () => null,
    }
  },

  addProseMirrorPlugins() {
    return [
      createTrackChangesPlugin({
        getEnabled: this.options.getEnabled,
        getCurrentUser: this.options.getCurrentUser,
      }),
    ]
  },

  addKeyboardShortcuts() {
    return {
      Tab: () => runListCommandWithTracking(this.editor, this.options, (chain) => chain.sinkListItem(LIST_ITEM_NODE_NAME)),
      'Shift-Tab': () => runListCommandWithTracking(this.editor, this.options, (chain) => chain.command(liftListItemSingleLevel)),
      Backspace: () => mergeListItemBackward(this.editor, this.options),
    }
  },
})
